import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/base/SEO';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedComics from './components/FeaturedComics';
import LatestUpdates from './components/LatestUpdates';
import FAQSection from './components/FAQSection';

const CANONICAL_URL = 'https://www.hanmanzhijia.com';

export default function Home() {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '韩漫之家',
    url: CANONICAL_URL,
    description: '韩漫之家让您免费在线观看下拉式韩漫，精选好看的漫画大全，从浪漫到动作题材应有尽有，帮助您快速找到心仪作品并享受流畅阅读体验。',
    potentialAction: {
      '@type': 'SearchAction',
      target: `${CANONICAL_URL}/search?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      { '@type': 'Question', name: '韩漫之家是免费的吗？', acceptedAnswer: { '@type': 'Answer', text: '是的，韩漫之家完全免费！我们致力于为广大韩漫爱好者提供优质的免费阅读体验。所有漫画均可在网站上免费在线观看，无需付费订阅。' } },
      { '@type': 'Question', name: '什么是下拉式韩漫？', acceptedAnswer: { '@type': 'Answer', text: '下拉式韩漫是韩国漫画独特的阅读方式，漫画内容纵向排列，读者只需向下滑动即可连续阅读。这种形式非常适合手机端阅读，让您随时随地畅享韩漫。' } },
      { '@type': 'Question', name: '网站支持哪些设备访问？', acceptedAnswer: { '@type': 'Answer', text: '韩漫之家支持所有主流设备访问，包括电脑、平板和手机。我们的网站采用响应式设计，会根据您的设备屏幕自动调整显示效果，确保最佳的阅读体验。' } },
      { '@type': 'Question', name: '漫画更新的频率是怎样的？', acceptedAnswer: { '@type': 'Answer', text: '连载中的作品通常每周更新一到两话，具体更新频率取决于作者和版权方安排。我们会在第一时间同步更新，您可以关注喜欢的作品获取最新通知。' } },
      { '@type': 'Question', name: '如何找到我喜欢的漫画类型？', acceptedAnswer: { '@type': 'Answer', text: '您可以通过首页的分类导航浏览不同类型的漫画，也可以在搜索框中直接输入作品名称或作者进行搜索。我们提供了浪漫爱情、热血动作、奇幻冒险等多种分类供您选择。' } },
      { '@type': 'Question', name: '网站上可以下载漫画吗？', acceptedAnswer: { '@type': 'Answer', text: '目前韩漫之家仅支持在线阅读，暂不提供下载功能。我们建议您将喜欢作品的页面加入书签，方便下次快速访问继续阅读。' } },
    ],
  };

  return (
    <>
      <SEO
        title="首页"
        description="韩漫之家让您免费在线观看下拉式韩漫，精选好看的漫画大全，从浪漫到动作题材应有尽有，帮助您快速找到心仪作品并享受流畅阅读体验。"
        keywords="韩国漫画免费,在线观看下拉式,好看的漫画大全,韩漫之家"
        canonicalUrl={CANONICAL_URL}
        ogImage="https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20style%20artistic%20banner%20with%20warm%20coral%20and%20amber%20colors%2C%20elegant%20composition%2C%20clean%20minimal%20design%2C%20comic%20reading%20theme%2C%20warm%20atmosphere&width=1200&height=630&seq=og-home&orientation=landscape"
        schema={{ ...schema, ...faqSchema }}
      />

      <Navbar />

      <main>
        <HeroSection />
        <CategoryNav />
        <FeaturedComics />
        <LatestUpdates />

        {/* CTA Banner */}
        <section className="relative py-16 md:py-20 overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20soft%20flowing%20shapes%2C%20coral%20and%20amber%20color%20palette%2C%20minimal%20elegant%20texture%2C%20digital%20art%20style%2C%20smooth%20gradients%2C%20warm%20atmosphere&width=1920&height=400&seq=cta-banner-comic&orientation=landscape"
            alt=""
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-primary-500/85"></div>
          <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
            <h2 className="font-heading text-2xl md:text-4xl text-background-50 mb-4">
              准备好开启你的韩漫之旅了吗？
            </h2>
            <p className="text-background-200 text-sm md:text-base mb-6">
              数百部精选韩漫等你来发现，不限时不限量，随时随地免费阅读
            </p>
            <a
              href="/category/romance"
              className="inline-block px-8 py-3 bg-background-50 text-primary-600 rounded-full font-medium text-sm hover:bg-background-100 transition-all duration-200 cursor-pointer whitespace-nowrap"
              onClick={(e) => {
                e.preventDefault();
                window.scrollTo({ top: 0, behavior: 'smooth' });
                window.REACT_APP_NAVIGATE?.('/category/romance');
              }}
            >
              立即探索
            </a>
          </div>
        </section>

        <FAQSection />
      </main>

      <Footer />
    </>
  );
}